export default function usersTranslator(message, dispatch) {
  switch(message.update) {
    case "user updated":
      dispatch({type: "user/update", user: message.user});
  }
}
